import request from '@/utils/request'
const api_name = 'leaseinfo'
export default{
    getAllLeaseInfos(){
        return request({
            url:`/${api_name}/getallleaseinfos`,
            method:'get'
        })
    },
    getLeaseInfoByName(pojo){
        return request({
            url:`/${api_name}/getleaseinfobyname`,
            method:'post',
            data:pojo
        })
    },
    addleaseinfo(pojo){
        return request({
            url:`/${api_name}/addleaseinfovo`,
            method:'post',
            data:pojo
        })
    },
    updateleaseinfo(pojo){
        return request({
            url:`/${api_name}/updateleaseinfovo`,
            method:'post',
            data:pojo
        })
    },
    deleteleaseinfo(id){
        return request({
            url:`/${api_name}/deleteleaseinfovo?leaseid=`+id,
            method:'post',
        })
    },
    
}







